import { createAsyncThunk } from "@reduxjs/toolkit";
import {
	login as loginService,
	refreshToken as refreshTokenService,
	register as registerService,
	registerRequest as registerRequestService,
	validateOtp as validateOtpService,
} from "services/authService";

/**
 * Login Thunk
 */
export const loginThunk = createAsyncThunk(
	"auth/login",
	async (
		{
			username,
			password,
			credType = "email",
		}: {
			username: string;
			password: string;
			credType?: "email" | "phone";
		},
		{ rejectWithValue },
	) => {
		try {
			const res = await loginService(username, password, credType);
			return res?.data?.data ?? res?.data ?? res;
		} catch (error: any) {
			return rejectWithValue(error?.message || "Login failed");
		}
	},
);

/**
 * Refresh Token Thunk
 */
export const refreshTokenThunk = createAsyncThunk(
	"auth/refreshToken",
	async (_, { rejectWithValue }) => {
		try {
			return await refreshTokenService();
		} catch (error: any) {
			return rejectWithValue(error.message);
		}
	},
);

/**
 * Register Request Thunk
 */
export const registerRequestThunk = createAsyncThunk(
	"auth/registerRequest",
	async (
		payload: { role_id: number; email?: string; phone?: string },
		{ rejectWithValue },
	) => {
		try {
			return await registerRequestService(payload); // <— updated call/signature
		} catch (error: any) {
			return rejectWithValue(error.message);
		}
	},
);

/** Validate OTP (email or phone) */
export const validateOtpThunk = createAsyncThunk(
	"auth/validateOtp",
	async (
		payload: { otp: string; email?: string; phone?: string },
		{ rejectWithValue },
	) => {
		try {
			return await validateOtpService(payload); // { otp, email?, phone? }
		} catch (error: any) {
			return rejectWithValue(error.message);
		}
	},
);

/**
 * Register Thunk
 */
export const registerThunk = createAsyncThunk(
	"auth/register",
	async (
		payload: {
			email?: string;
			phone?: string;
			password: string;
			roleID: number;
			otp: string;
		},
		{ rejectWithValue },
	) => {
		try {
			console.log("registerThunk payload:", payload);
			return await registerService(payload); // { email?, phone?, password, roleID, otp }
		} catch (error: any) {
			return rejectWithValue(error.message);
		}
	},
);
